<template>
   <div>
       <froalaView v-model="tempText"></froalaView>
   </div>
</template>

<script>
    export default {
        props: ['client'],
        data(){
            return {
                tempText: this.client.preferred_communication,
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/clients/ClientCommunication.vue